const global = {
  //放行單重量呈現取到小數點第幾位
  defaultPointNumForRelease: 4,
  erpReserveType: ["ERP", "ERP_ONE"],
}

export { global }
